import $ from "jquery";

/*
 * -------------------------------------------------------------------------------------------------------
 * 클라이언트 컨트롤의 이벤트(onclick, onkeydown 등)와 관련된 자바스크립트 함수 모음
 * -------------------------------------------------------------------------------------------------------
*/

const CommonUtil = {

    /**
    * 팝업 보기(공통)
    * @param {string} url  호출 URL 주소
    * @param {string} name 팝업명
    * @param {string} option 팝업창 옵션
    * @returns {void}
    */
    win_open: (url: string, name: string, option: string): void => {
        var popup = window.open(url, name, option);
        if (popup) {
            popup.opener = window.self;
            popup.focus();
        }
    },

    /**
    * 특정 쿼리스트링 값 가져오는 함수
    * @param {string} key 쿼리스트링 키 값
    * @param {string} def 키 값 없을 경우, 반환 될 기본 값
    * @returns {string} 요청 쿼리스트링 값 반환
    */
    getQuerystring: (key: string, def: string): string => {
        if (def === null) {
            def = "";
        }
        var search = window.location.search;
        if (search === "") {
            return def;
        }
        search = search.substring(1);
        var params = search.split("&");
        for (var i = 0; i < params.length; i++) {
            var pairs = params[i].split("=");
            if (pairs[0] === key) {
                return decodeURIComponent(pairs[1]);
            }
        }
        return def;
    },

    /**
    * 외부 js 라이브러리 실행 함수
    * @param {string} queryString 쿼리스트링 문자열
    * @returns {void}
    */
    externalScriptExec: (queryString: string): void => {

        var externalScriptExec = $("#externalScriptExec");

        var interval_id = setInterval(() => {

            if (externalScriptExec.length > 0) return;
            clearInterval(interval_id);

            var externalScriptExec_js = $("<script type=\"text/javascript\" id=\"externalScriptExec\" src=\"/externalScriptExec.js" + queryString + "\"></script>");
            $("body").append(externalScriptExec_js);
        }, 500);
    },

    /**
    * SNS 공유하기 버튼 클릭 이벤트
    * 
    * @param {React.MouseEvent<HTMLAnchorElement, MouseEvent>} e 이벤트 객체
    * @returns {void}
    */
    handlerSnsShare: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, func_name: string): void => {
        e.preventDefault();

        CommonUtil.externalScriptExec(
            "?req=snsModule"
            + "&func_name=" + encodeURIComponent(func_name)
        );
    },

    /**
    * 각종 더미 파라미터 추가 (구글 애드센스 광고 노출을 원활하게 하기 위해서는 의미없는 파라메터 몇 개가 필요한 상황이라 추가된 기능)
    * @param {string} def_url 기본 URL
    * @returns {string}
    */
    Add_Dummy_Parameter: function (def_url: string): string {

        // 현재 날짜 가져오기
        var dummy_today = CommonUtil.getCurrDateTimeString();

        var dummy_parameter = def_url;

        if (dummy_parameter.indexOf("date=") === -1) {
            dummy_parameter = ""
                + (dummy_parameter.indexOf("?") === -1 ? dummy_parameter + "?" : dummy_parameter + "&")
                + "date=" + encodeURIComponent(dummy_today);
        }

        if (dummy_parameter.indexOf("dummy=") === -1) {
            dummy_parameter = ""
                + (dummy_parameter.indexOf("?") === -1 ? dummy_parameter + "?" : dummy_parameter + "&")
                + "dummy=" + encodeURIComponent("1");
        }

        return dummy_parameter;
    },

    getCurrDateTimeString: (): string => {

        // 현재 날짜 가져오기
        var dateObj = new Date();
        var today = "";
        var ss = dateObj.getSeconds().toString();
        var min = dateObj.getMinutes().toString();
        var hh = dateObj.getHours().toString();
        var dd = dateObj.getDate().toString();
        var mm = (dateObj.getMonth() + 1).toString();
        var yyyy = dateObj.getFullYear();
        if (parseInt(ss, 10) < 10) ss = '0' + ss;
        if (parseInt(min, 10) < 10) min = '0' + min;
        if (parseInt(hh, 10) < 10) hh = '0' + hh;
        if (parseInt(dd, 10) < 10) dd = '0' + dd;
        if (parseInt(mm, 10) < 10) mm = '0' + mm;
        today = yyyy + "" + mm + "" + dd + "" + hh + "" + min + "" + ss;

        return today;
    },

    /**
    * 모바일 기기인지 여부 값 반환
    * @returns {boolean} 모바일 기기 여부(true/false)
    */
    isMobileOs: function (): boolean {

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent)) {
            // 모바일 기기일 경우

            return true;
        }
        else {
            // 그 외

            return false;
        }
    },
    autoLink: function (str: string, options?: { [key: string]: any }): string {
        const pattern = /(^|[\s\n]|<[A-Za-z]*\/?>)((?:https?|ftp):\/\/[\-A-Z0-9+\u0026\u2019@#\/%?=()~_|!:,.;]*[\-A-Z0-9+\u0026@#\/%=~()_|])/gi;
        if (!options) {
            return str.replace(pattern, "$1<a href='$2'>$2</a>");
        }

        const linkAttributes = Object.entries(options)
            .filter(([k]) => k !== 'callback')
            .map(([k, v]) => ` ${k}='${v}'`)
            .join('');

        const callback = options.callback;

        return str.replace(pattern, function (match, space, url) {
            const link = typeof callback === 'function'
                ? callback(url)
                : `<a href='${url}'${linkAttributes}>${url}</a>`;
            return `${space}${link}`;
        });
    },

    /**
    * 특정 스크롤 위치로 이동
    */
    scrollTo: function (selector: JQuery | Element | string | number, addPx: number = 0, duration: number = 0) {
        function getScroller(): JQuery {
            const se = document.scrollingElement || document.documentElement;
            return $(se as HTMLElement);
        }

        function getTopWithinContainer($target: JQuery<HTMLElement | Element>, $container: JQuery<HTMLElement | Element>): number {
            // 문서 스크롤러면 그냥 offset().top
            const cEl = $container[0];
            const docEl = document.scrollingElement || document.documentElement;

            if (cEl === docEl || cEl === document.body) {
                return $target.offset()?.top ?? 0;
            }
            // 내부 컨테이너면 컨테이너 기준으로 보정
            const cTop = $container.offset()?.top ?? 0;
            const tTop = $target.offset()?.top ?? 0;
            const cScroll = $container.scrollTop() ?? 0;
            return tTop - cTop + cScroll;
        }

        const $c = getScroller();

        let targetTop = 0;
        if (typeof selector === 'number') {
            targetTop = selector;
        } else {
            const $t = selector instanceof $ ? selector as JQuery
                : typeof selector === 'string' ? $(selector).first()
                    : $(selector as Element);

            if (!$t.length) return; // 대상 없음
            targetTop = getTopWithinContainer($t, $c);
        }

        // duration=0이면 일부 환경에서 set처럼 동작하니 최소 1ms 권장
        $c.stop(true, false).animate(
            { scrollTop: targetTop + addPx },
            Math.max(1, duration)
        );
    }
}

export default CommonUtil;

(window as any).CommonUtil = CommonUtil; // 전역에 노출